export const AmbassadorFourth = {
  FOURTH_DESC:
    'Passionate about building relationships and ready to make a difference? We’d love to hear from you.',
};
